<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
  }
}
</script>

<template>
  <div v-if="title" class="">
    <h2 class="text-2xl mb-4 font-bold text-gray-900">
      {{ title }}
    </h2>
    <div class="mt-3">
      <slot />
    </div>
  </div>
  <div v-else class="py-5 lg:py-10 xl:py-15">
    <slot />
  </div>
</template>
